var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8125 18H15V3.1875C15 2.625 14.5 2.1875 14 2.1875C13.9375 2.1875 13.875 2.1875 13.875 2.1875C6.4375 3.25 0.75 9.75 1 17.5625C1.25 25.3125 7.6875 31.75 15.4375 32C15.625 32 15.8125 32 16 32C23.5625 32 29.75 26.4375 30.8125 19.125C30.875 18.5625 30.375 18 29.8125 18ZM16 30C15.8125 30 15.6875 30 15.5 30C8.8125 29.8125 3.1875 24.1875 3 17.5C2.75 11.25 7 5.8125 13 4.375V20H28.625C27.25 25.8125 22 30 16 30ZM19 0.0625C19 0.0625 19 0 18.9375 0C18.4375 0 18 0.5 18 1.0625V15H31.9375C32.5 15 33 14.5625 32.9375 14C32.4375 6.5 26.5 0.5625 19 0.0625ZM20 13V2.125C25.5625 3 30 7.4375 30.875 13H20Z",
    fill: "#97AEB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.6a118358.svg";
export { ForwardRef as ReactComponent };